import React, {Component} from 'react'
import {ItemFinalBill, AddDiscountModal, AddUnitModal, AddGstModal, BarCodeInput} from './utils'
import {AddBrandModal} from '../modal/modal'
import {API_BASE_URL} from '../../constants'
import axios from 'axios'
import html2canvas from 'html2canvas';
import {getToken, getUserSettings} from '../../storage'
import {Loader, removeZeros} from '../../utils/misc'
import Select from 'react-select';
import {Glyphicon, Alert} from 'react-bootstrap'
import BatchList from '../batch/batchlist'
import {basicRate, calculateTax, calculateSellingPrice} from '../../utils/calculator'
import {NotificationManager} from 'react-notifications'
import 'react-select/dist/react-select.css';

import JsBarcode from 'jsbarcode';
let downloadReady = false;
class Barcode extends React.Component {
  constructor(){
    super()
    this.downloadBarcode = this.downloadBarcode.bind(this)

  }

  downloadBarcode(e) {
    e.preventDefault()
    let canvas = document.getElementById('barcode')
    var image = canvas.toDataURL("image/jpg");

    this.refs.databarcode.href=image
    this.refs.databarcode.click()

  }

  componentDidMount() {
    try {
      JsBarcode("#barcode", this.props.value, {height:this.props.height,displayValue:this.props.displayValue, fontSize:15})
    } catch (e) {
      console.log(e);
    }
  }
  componentDidUpdate() {
    try {
      JsBarcode("#barcode", this.props.value, {height:this.props.height,displayValue:this.props.displayValue, fontSize:15})
    } catch (e) {
      console.log(e);
    }
  }

  render() {


    return <div className="text-left">
    <div>
      <canvas id="barcode" ref="renderElement" />
    </div>
    <div>
      <button className="btn btn-xs btn-success" ref="download" onClick={this.downloadBarcode}><Glyphicon glyph="download"/> Just Barcode</button>
      <a id="databarcode" href="" ref="databarcode" download={"item_"+this.props.value+".png"} target={"_blank"}></a>
    </div>
    </div>
  }
}
class BarcodeStyled extends React.Component {
  constructor(){
    super()
    this.downloadBarcode = this.downloadBarcode.bind(this)
    this.saveAs = this.saveAs.bind(this)
  }

  saveAs(uri, filename) {
      var link = document.createElement('a');
      if (typeof link.download === 'string') {
          link.href = uri;
          link.download = filename;
          //Firefox requires the link to be in the body
          document.body.appendChild(link);
          //simulate click
          link.click();
          //remove the link when done
          document.body.removeChild(link);
      } else {
          window.open(uri);
      }
  }


  downloadBarcode(e, scale=1) {
    e.preventDefault()
    html2canvas(document.getElementById(this.props.domNode),{scale:scale}).then((canvas)=> {
      this.saveAs(canvas.toDataURL(), this.props.filename);
    });
  }

  componentDidMount() {
    try {
       JsBarcode("#barcodestyled", this.props.value, {height:this.props.settings.item_barcode_height,displayValue:false, margin:0, fontSize:15})
    } catch (e) {
      console.log(e);
    }
  }

  componentDidUpdate() {
    try {
       JsBarcode("#barcodestyled", this.props.value, {height:this.props.settings.item_barcode_height,displayValue:false, margin:0, fontSize:15})
    } catch (e) {
      console.log(e);
    }
  }

  render() {
    let priceOption = this.props.settings.item_barcode_price_option === 'M' ? Number(this.props.item.mrp): Number(this.props.item.selling_rate)
    let fontFamily = this.props.settings.item_barcode_font_family === 'D' ? 'inherit' : 'Times New Roman'
    return <div className="text-left">
    <div id="barcodestyled_wrapper" style={{padding:5,color:'#000', fontFamily:fontFamily}}>
      <div>{this.props.settings.item_barcode_text_top}</div>
      <div><strong>#{this.props.value} {this.props.item.name}</strong></div>
      <canvas id="barcodestyled" ref="renderElement" />
      <div>{this.props.settings.item_barcode_text_bottom} Rs.{priceOption}</div>
    </div>
    <div>
      <ul className="list-inline">
      <li>
        <button className="btn btn-xs btn-success" ref="download" onClick={(e)=>{this.downloadBarcode(e)}}><Glyphicon glyph="download"/> Styled Barcode</button>
      </li>
      <li>
        <button className="btn btn-xs btn-success" ref="download" onClick={(e)=>{this.downloadBarcode(e, 2)}}><Glyphicon glyph="download"/> Scale 2</button>
      </li>
      <li>
        <button className="btn btn-xs btn-success" ref="download" onClick={(e)=>{this.downloadBarcode(e, 3)}}><Glyphicon glyph="download"/> Scale 3</button>
      </li>
    </ul>
    </div>
    </div>
  }
}

class UnitNameExtended extends React.Component {

  render() {

    let option = this.props.option

    if(typeof option.className !== "undefined") {
      return <div>Create new unit ?</div>
    }
    else {
      if(typeof option.container_unit !== "undefined" && option.container_unit !== null && option.container_unit.length > 0) {

        if(option.primary_unit_code !== null && option.primary_unit_code.length > 0) {
          return <div>{option.primary_unit_code}-{option.primary_unit} ({option.container_unit} = {option.container_volume} {option.primary_unit})</div>
        }
        else {
          return <div>{option.primary_unit} ({option.container_unit} = {option.container_volume} {option.primary_unit})</div>
        }


      }
      else if(option.primary_unit_code !== null && option.primary_unit_code.length > 0) {
        return <div>{option.primary_unit_code} ({option.primary_unit})</div>
      }
      else {
        return <div>{option.primary_unit}</div>
      }
    }
  }
}

class EditItem extends Component {
  constructor(props) {
    super(props)
    this.handleInputChange = this.handleInputChange.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
    this.handleGstChange = this.handleGstChange.bind(this)
    this.handleDateChange= this.handleDateChange.bind(this)
    this.createDiscountPromt = this.createDiscountPromt.bind(this)
    this.createUnitPromt = this.createUnitPromt.bind(this)
    this.handleUnitChange = this.handleUnitChange.bind(this)
    this.handleBrandChange = this.handleBrandChange.bind(this)
    this.handleDiscountChange = this.handleDiscountChange.bind(this)
    this.handleAddNewDiscount = this.handleAddNewDiscount.bind(this)
    this.handleAddNewUnit = this.handleAddNewUnit.bind(this)
    this.handleAddNewGst = this.handleAddNewGst.bind(this)
    this.modifyItemState = this.modifyItemState.bind(this)
    this.handleAddNewBrand = this.handleAddNewBrand.bind(this)
    this.handleAfterTaxChange = this.handleAfterTaxChange.bind(this)
    this.handleBeforeTaxChange = this.handleBeforeTaxChange.bind(this)
    this.handleUnitModal  = this.handleUnitModal.bind(this)
    this.handleGstModal  = this.handleGstModal.bind(this)
    this.handleBrandModal  = this.handleBrandModal.bind(this)
    this.handleBatchModal = this.handleBatchModal.bind(this)
    this.deleteItem = this.deleteItem.bind(this)
    this.state = {loading:true, is_item_batches:false, item:{name:"", hsn:"", serial_barcode:"", quantity:undefined, opening_stock:0, unit:undefined, brand:undefined,
      mrp:0, purchase_basic_rate:0, selling_basic_rate:0, selling_rate:0, gst:undefined,
      cess_percentage:0, specific_cess_amount:0,
      discounts:[]}}
  }

  handleUnitModal() {
    this.setState({
      showUnitCreate:false
    })
  }

  handleGstModal() {
    this.setState({
      showGstCreate:false
    })
  }
  handleBrandModal() {
    this.setState({
      showBrandCreate:false
    })
  }
  handleBatchModal() {
    this.setState({
      showBatchCreate:false
    })
  }

  componentDidMount() {

    let settings = getUserSettings()

    if(typeof this.props.match !=="undefined" && typeof this.props.match.params.item_id !== "undefined") {
      this.setState({mode:'edit'})
      document.title = "Edit Item " + this.props.match.params.item_id
      this.getItem(this.props.match.params.item_id).then((response)=>{
        if(response.status===200) {
          this.setState({item: response.data.item, loading:false})
        }
      }).catch((err)=>{
        this.setState({loading:false})
      })
    }
    else {
      document.title = "Create Item "
      this.setState({loading:false})

      if(typeof settings !== "undefined" && settings !== null && settings.item_default_unit) {
        this.modifyItemState('unit', settings.item_default_unit)
      }
    }

    if(typeof settings !== "undefined" && settings !== null && settings.item_track_batches) {
      this.setState({is_item_batches:true})
    }

  }

  getItem(item_id) {
    return axios({
      url: '/get_item/?serial='+item_id,
      baseURL: API_BASE_URL,
      headers: {
        common: {
          'Authorization': 'Token ' + getToken()
        }
      }
    })
  }

  deleteItem() {
    axios({
      url: '/delete_item/',
      method: 'post',
      baseURL: API_BASE_URL,
      headers: {
        common: {
          'Authorization': 'Token ' + getToken()
        },
        post: {
          'Content-Type': 'multipart/form-data;'
        }
      },
      data: this.state.item
    }).then((response)=> {
      if(response.status === 200) {
          NotificationManager.success("Deleted item successfully")
        setTimeout(()=>{
          if(this.state.mode === "edit") {
              this.props.history.goBack()
          }
          else {
              this.props.history.push("/items/")
          }

        }, 700)
      }
    }).catch((err)=> {

      if(typeof err.response !== "undefined" && err.response.data !== "undefined") {
        this.setState({deleteError: err.response.data.msg})
      }

    })
  }



  modifyItemState(key, value) {
        let currentItem = this.state.item
        currentItem[key] = value
        this.setState({
          item: currentItem
       });
       console.log(currentItem);
  }

  createUnitPromt(){
    return "Create new unit ?"
  }

  createDiscountPromt(){
    return "Create new discount ?"
  }

  getDiscounts (input) {
    return   axios({
        url: '/list_discounts/?q='+input,
        method: 'get',
        baseURL: API_BASE_URL,
        headers: {
          common: {
            'Authorization': 'Token ' + getToken()
          }
        }
      }).then((response)=> {
            return {options: response.data.discounts}
      }).catch((err)=> {
        console.log(err);
        return Promise.resolve({ options: [] });
      })
}

getBrands (input) {

  return   axios({
      url: '/list_brands/?q='+input,
      method: 'get',
      baseURL: API_BASE_URL,
      headers: {
        common: {
          'Authorization': 'Token ' + getToken()
        }
      }
    }).then((response)=> {
          return {options: response.data.brands}
    }).catch((err)=> {
      console.log(err);
      return Promise.resolve({ options: [] });
    })
}

getUnits (input) {
  if (!input) {
    return axios({
        url: '/list_units/',
        method: 'get',
        baseURL: API_BASE_URL,
        headers: {
          common: {
            'Authorization': 'Token ' + getToken()
          }
        }
      }).then((response)=> {
            return {options: response.data.units}
      }).catch((err)=> {
        console.log(err);
        return Promise.resolve({ options: [] });
      })
  }
  return   axios({
      url: '/list_units/?q='+input,
      method: 'get',
      baseURL: API_BASE_URL,
      headers: {
        common: {
          'Authorization': 'Token ' + getToken()
        }
      }
    }).then((response)=> {

          return {options: response.data.units}
    }).catch((err)=> {
      console.log(err);
      return Promise.resolve({ options: [] });
    })
}

getGsts (input) {

  return   axios({
      url: '/list_gsts/?q='+input,
      method: 'get',
      baseURL: API_BASE_URL,
      headers: {
        common: {
          'Authorization': 'Token ' + getToken()
        }
      }
    }).then((response)=> {
          return {options: response.data.gsts}
    }).catch((err)=> {
      console.log(err);
      return Promise.resolve({ options: [] });
    })
}

handleAddNewDiscount(discount) {
  let discounts = this.state.item.discounts
  if(typeof discounts === "undefined") {
    discounts = []
  }

  discounts.push(discount)
  this.modifyItemState('discounts', discounts)
  this.setState({showDiscountCreate:false})

}

handleAddNewUnit(unit) {

  this.modifyItemState('unit', unit)
  this.setState({showUnitCreate:false})
}

handleAddNewGst(gst) {
  this.modifyItemState('gst', gst)
  this.setState({showGstCreate:false})
  this.handleGstChange(gst)
}

handleAddNewBrand(brand) {
  this.modifyItemState('brand', brand)
  this.setState({showBrandCreate:false})
}
handleAddNewBatch(batch) {
  let existingBatches = this.state.item.batches
  if(typeof existingBatches === "undefined" || existingBatches === null) {
    existingBatches = []
  }
  existingBatches.push(batch)
  this.modifyItemState('batches', existingBatches)
  this.setState({showBatchCreate:false})
}

handleGstChange(gst, sbr){
  this.setState({
    showGstCreate:false
  })
  if(gst !== null && typeof gst.id === "string") {
    this.setState({
      showGstCreate:true
    })
  }
  else if (gst !== null) {
    var selling_basic_rate = (typeof sbr === "undefined" ? this.state.item.selling_basic_rate : sbr)
    var cgst = parseFloat(gst.cgst), sgst=parseFloat(gst.sgst), igst = parseFloat(gst.igst)
    var cgst_amount = calculateTax(parseFloat(selling_basic_rate), cgst)
    var igst_amount = calculateTax(parseFloat(selling_basic_rate), igst)
    this.modifyItemState('cgst_amount', cgst_amount)
    this.modifyItemState('sgst_amount', cgst_amount)
    this.modifyItemState('igst_amount', igst_amount)

    this.modifyItemState('selling_rate', calculateSellingPrice(parseFloat(selling_basic_rate), cgst+sgst))
    this.modifyItemState('gst', gst)
  }
  else {
    this.modifyItemState('gst', undefined)
  }
}

handleBeforeTaxChange(e) {
     if(typeof this.state.item.gst !== "undefined") {
       this.handleGstChange(this.state.item.gst, e.target.value)
     }
     this.modifyItemState('selling_basic_rate', e.target.value)
}

handleAfterTaxChange(e) {

    let value = e.target.value, gst = this.state.item.gst
    if(typeof gst !== "undefined") {
        let br = basicRate(parseFloat(value), gst.igst)
      this.modifyItemState('selling_basic_rate', br)
    }
    this.modifyItemState('selling_rate', value)
}


handleUnitChange(unit){

  this.setState({
    showUnitCreate:false
  })
  if(unit !== null && typeof unit.id === "string") {
    this.setState({
      showUnitCreate:true
    })
  }
  else if (unit !== null) {
    this.modifyItemState('unit', unit)
  }
  else {
    this.modifyItemState('unit', undefined)
  }
}

handleBrandChange(brand){

  this.setState({
    showBrandCreate:false
  })
  if(brand !== null && typeof brand.id === "string") {
    this.setState({
      showBrandCreate:true
    })
  }
  else if (brand !== null) {
    this.modifyItemState('brand', brand)
  }
  else {
    this.modifyItemState('brand', undefined)
  }
}

handleBatchChange(batch) {
  this.setState({
    showBatchCreate:false
  })
  if(batch !== null && typeof batch.id === "string") {
    this.setState({
      showBatchCreate:true
    })
  }
  else if (batch !== null) {
    let existingBatches = this.state.item.batches
    if(typeof existingBatches === "undefined" || existingBatches === null) {
      existingBatches = []
    }
    existingBatches.push(batch)
    this.modifyItemState('batches', existingBatches)
  }
  else {
    this.modifyItemState('batches', [])
  }
}

handleDiscountChange(discounts){
  this.setState({
    showDiscountCreate:false
  })
  if(discounts !== null) {
    let selectedFromExisting = true
      discounts.forEach((d,i)=>{
        // if there is type string id then create option selectied/
         if(typeof d.id === "string" && typeof d.className !== "undefined") {
           selectedFromExisting = false
           this.setState({
             showDiscountCreate:true
           })
         }
      })
      if(selectedFromExisting) {
        this.modifyItemState('discounts', discounts)
      }
  }
  else {
    this.modifyItemState('discounts', [])
  }
}


  handleDateChange(value, fValue) {
    this.modifyItemState('available_from', fValue)
    this.modifyItemState('available_from_date', value)

  }

  handleSerialBarcodeChange = (item)=>{
    this.modifyItemState('serial_barcode', item.serial_barcode)
  }



  handleInputChange(event) {
    const target = event.target;
    let value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;
    this.modifyItemState(name, value)
  }


  handleSubmit(event) {
    event.preventDefault()

    if(this.state.item.quantity === "") {
      this.state.item.quantity = 0
    }
    if(this.state.item.purchase_basic_rate === "") {
      this.state.item.purchase_basic_rate = 0
    }
    if(this.state.item.selling_basic_rate === "") {
      this.state.item.selling_basic_rate = 0
    }
    if(this.state.item.selling_rate === "") {
      this.state.item.selling_rate = 0
    }
    if(this.state.item.mrp === "") {
      this.state.item.mrp = 0
    }
    if(this.state.item.specific_cess_amount === "") {
      this.state.item.specific_cess_amount = 0
    }
    if(this.state.item.cess_percentage === "") {
      this.state.item.cess_percentage = 0
    }

    if(!this.state.submitting) {
      this.setState({'submitting':true})
      let apiurl
      if(typeof this.state.mode !== "undefined" && this.state.mode === "edit"){
        apiurl = '/update_item/'
      }
      else {
        apiurl = '/create_new_item/'
      }
      let data = Object.assign({},this.state.item)
      delete data['purchaseitem_set']

      axios({
        url: apiurl,
        method: 'post',
        baseURL: API_BASE_URL,
        headers: {
          common: {
            'Authorization': 'Token ' + getToken()
          },
          post: {
            'Content-Type': 'multipart/form-data;'
          }
        },
        data: data
      }).then((response)=> {
        this.setState({'submitting': false})
        if(response.status === 200) {
          //this.props.dispatch(addingItemSuccess(response.data.item))
          if(typeof this.props.noredirect !== "undefined") {
            // if somebody says no redirect, then dont.
          }
          else if(typeof this.props.onAddCallback !== "undefined") {
            this.props.onAddCallback(response.data.item)
          }
          else {
            if(this.state.mode ==="edit") {
                NotificationManager.success("Updated item successfully")
            }
            else {
                NotificationManager.success("Created item successfully")
            }
            setTimeout(()=>{
              if(this.state.mode === "edit") {
                  this.props.history.goBack()
              }
              else {
                  this.props.history.push("/items/")
              }
            }, 700)
          }
        }
      }).catch((err)=> {
        console.log(err);
        this.setState({'submitting': false})
      })

    }


  }

  discountRenderer(option) {

    if(typeof option.is_percentage !== "undefined") {

      if(option.is_percentage) {
          return <div>{option.quantity} units {option.rate}%</div>
      }
      else {
          return <div>{option.quantity} units  Rs.{option.value}</div>
      }

    }
    else {
      return <div>Create New Discount ?</div>
    }
  }

  renderOption(option){
    return <UnitNameExtended option={option} />
  }

  render() {


    let settings = getUserSettings()
    let manual_barcode = false
    let enable_stock_warnings = false
    if(settings) {
      let settingOptions = settings.options
      if(settingOptions && settingOptions.enable_item_additional_barcode) {
        manual_barcode =true
      }
      if(settingOptions && settingOptions.enable_stock_warnings) {
        enable_stock_warnings = true
      }
    }




    let submitButton = <input type="submit" className="btn btn-success" value="save" />
    if(this.state.submitting) {
      submitButton = <input type="submit" className="btn btn-success" value="saving.." disabled />
    }
    let submitError

let item = {}

if(typeof this.state.item !== "undefined" && this.state.item !== null) {
  item = this.state.item
}


let opening_stock_form

if(!this.state.is_item_batches) {

  let quantityValue = ""
  if(item.quantity) {
    quantityValue = Number(item.quantity)
  }


    opening_stock_form = <div className="form-group">
<label className="col-sm-4  ">
  Opening Stock
</label>
<div className="col-sm-8">
    <input name="quantity" type="number" value={quantityValue} className="form-control " onChange={this.handleInputChange}  />
</div>
    </div>
}

let serialBarcode
if(manual_barcode) {
  serialBarcode = <div className="form-group">
    <label className="col-sm-4  ">
      Barcode
    </label>
    <div className="col-sm-8">
      <BarCodeInput item={item} name="serial_barcode" onChangeCallback={this.handleSerialBarcodeChange} />
    </div>
  </div>

}

let stock_warning_input
if(enable_stock_warnings) {
  stock_warning_input= <div className="form-group">
  <label className="col-sm-4    ">
    Stock Warning Limit
  </label>
  <div className="col-sm-8">
      <input name="warning_closing_stock" type="text" value={item.warning_closing_stock} className="form-control  " onChange={this.handleInputChange}  />
  </div>
  </div>
}


let brand = <Select.AsyncCreatable multi={false} value={item.brand} promptTextCreator={this.createBrandPromt}
    onChange={this.handleBrandChange} valueKey="id" labelKey="name" loadOptions={this.getBrands} />

let unit = <Select.AsyncCreatable multi={false} value={item.unit} promptTextCreator={this.createUnitPromt}
  optionRenderer={this.renderOption}
  valueRenderer = {this.renderOption}
  onChange={this.handleUnitChange} valueKey="id" labelKey="primary_unit" loadOptions={this.getUnits} />

    const leftForm = (
      <div >
        <div className="form-group">
    <label className="col-sm-4    ">
      Brand
    </label>
    <div className="col-sm-8">
        {brand}
    </div>
        </div>
          <div className="form-group">
      <label className="col-sm-4    ">
        Item Name <span>*</span>
      </label>
      <div className="col-sm-8">
          <input name="name" type="text" value={item.name} className="form-control  " onChange={this.handleInputChange} required />
      </div>
          </div>

          <div className="form-group">
      <label className="col-sm-4  ">
        HSN
      </label>
      <div className="col-sm-8">
          <input name="hsn" type="text" value={item.hsn} className="form-control  " onChange={this.handleInputChange}  />
      </div>
          </div>

          {opening_stock_form}

          <div className="form-group">
      <label className="col-sm-4  ">
        Unit
      </label>
      <div className="col-sm-8">
        {unit}
      </div>
          </div>



      </div>
    )


    let gst = <Select.AsyncCreatable multi={false} value={item.gst} promptTextCreator={this.createGstPromt}
      onChange={this.handleGstChange} valueKey="id" labelKey="name" loadOptions={this.getGsts} />



      let discounts = <div className="form-group">
        <label className="col-sm-4   ">
          Discounts
        </label>
        <div className="col-sm-8 ">
          <Select.AsyncCreatable multi={true} value={item.discounts}
             promptTextCreator={this.createItemPromt}
            valueRenderer={this.discountRenderer}
            optionRenderer = {this.discountRenderer}
              onChange={this.handleDiscountChange} valueKey="id" labelKey="name" loadOptions={this.getDiscounts} backspaceRemoves={true} />
        </div>
          </div>

        let purchase_basic_rate = ""

        if(item.purchase_basic_rate) {
          purchase_basic_rate = removeZeros(item.purchase_basic_rate)
        }


        let selling_basic_rate = ""
        if (item.selling_basic_rate) {
          selling_basic_rate = removeZeros(item.selling_basic_rate)
        }
        // if(selling_basic_rate > 0) {
        //   selling_basic_rate = removeZeros(selling_basic_rate)
        // }

        let selling_rate = ""
        if(item.selling_rate) {
          selling_rate = removeZeros(item.selling_rate)
        }
        // if(selling_rate > 0 ) {
        //   selling_rate = removeZeros(selling_rate)
        // }

        let mrp_rate = ""
        if(item.mrp) {
          mrp_rate = removeZeros(item.mrp)
        }

        let cess_percentage = ""
        if(item.cess_percentage) {
          cess_percentage = removeZeros(item.cess_percentage)
        }
        let specific_cess_amount = ""
        if(item.specific_cess_amount){
          specific_cess_amount = removeZeros(item.specific_cess_amount)
        }


        let priceWarning
        if(parseFloat(item.selling_basic_rate) <= parseFloat(item.closing_purchase_basic_rate)) {
          priceWarning = <Alert bsStyle="warning">
                          <strong>WARNING: </strong>Your selling price ({parseFloat(item.selling_basic_rate)}) is not higher than closing purchase rate ({parseFloat(item.closing_purchase_basic_rate)}). Means you are selling this item with no profits.
                        </Alert>
        }



        let purchase_without_tax_form

        if(!this.state.is_item_batches) {
            purchase_without_tax_form = <div className="form-group">
              <label className="col-sm-4  ">
                Purchase Value Without Tax
              </label>
              <div className="col-sm-8">
          <input name="purchase_basic_rate" placeholder="0.00" value={purchase_basic_rate} step=".001" type="number" min="0"  className="form-control  " onChange={this.handleInputChange}  />
              </div>
            </div>
        }


    const rightForm = (<div>

      {purchase_without_tax_form}

      <div className="form-group">
                    <label className="col-sm-4  ">
                      GST <span>*</span>
                    </label>
                    <div className="col-sm-8">
                      {gst}
                    </div>
      </div>


      <div className="form-group">
        <label className="col-sm-4  ">
          Selling Value Without Tax
        </label>
        <div className="col-sm-8">
    <input name="selling_basic_rate" placeholder="0.00" value={selling_basic_rate} step=".001" type="number" min="0" className="form-control  " onChange={this.handleBeforeTaxChange}  />
        </div>

      </div>



      <div className="form-group">
        <label className="col-sm-4  ">
        Selling Value with Tax
        </label>
        <div className="col-sm-8">
    <input name="selling_rate" placeholder="0.00" value={selling_rate} type="number" step=".001" min="0" className="form-control  " onChange={this.handleAfterTaxChange}  />
        </div>

      </div>

      <div className="form-group">
            <label className="col-sm-4  ">
              MRP
            </label>
            <div className="col-sm-8">
                <input name="mrp" placeholder="0.00" value={mrp_rate} type="number" step=".001" min="0" className="form-control  " onChange={this.handleInputChange}  />
            </div>
      </div>

      <div className="form-group">
        <label className="col-sm-4  ">
          CESS
          (% + Amount)
        </label>
        <div className="col-xs-3">
           <div className="input-group">
               <input name="cess_percentage" placeholder="0" value={cess_percentage} type="number" step=".01" min="0" className="form-control  " onChange={this.handleInputChange}  />
                 <div className="input-group-addon">%</div>
           </div>
        </div>
        <div className="col-xs-1 text-center">
          <b>+</b>
        </div>
        <div className="col-xs-4">
            <input name="specific_cess_amount" placeholder="0" value={specific_cess_amount} type="number" step=".001" min="0" className="form-control  " onChange={this.handleInputChange}  />
        </div>
      </div>



      <div className="form-group">
        <div className="col-xs-12">
          <ItemFinalBill state={this.state} gsts={item.gst} />
        </div>
      </div>
      {stock_warning_input}
      {discounts}
      {serialBarcode}
    </div>)

      let discountModal, unitModal, gstModal, brandModal
      if(this.state.showDiscountCreate) {
        discountModal = <AddDiscountModal onAddCallback={this.handleAddNewDiscount} />
      }

      unitModal  = <AddUnitModal show={this.state.showUnitCreate} handleModalToggle={this.handleUnitModal} onAddCallback={this.handleAddNewUnit} />
      gstModal = <AddGstModal show={this.state.showGstCreate} handleModalToggle={this.handleGstModal} onAddCallback={this.handleAddNewGst} />
      brandModal = <AddBrandModal show={this.state.showBrandCreate} handleModalToggle={this.handleBrandModal} onAddCallback={this.handleAddNewBrand} />


    let form = (<form className="form-horizontal" onSubmit={this.handleSubmit}>

        <div className="form-group">
          <div className="col-sm-4">
              {leftForm}
          </div>
          <div className="col-sm-6">
              {rightForm}
          </div>
        </div>
        <div className="form-action-group text-center">
           {submitButton}
        </div>
      </form>)


      let pageHeader, deleteItemBtn, deleteError, closing_stock, closing_purchase_basic_rate
      let batchList, barcode, barcode2

      if(!this.state.loading) {
        if(this.state.is_item_batches) {
            batchList = <BatchList item={this.state.item} />
        }

        if(this.state.mode === "edit") {

          if(typeof settings !== "undefined" && settings.enable_item_barcode) {

            let barcodeValue = item.serial

            if(manual_barcode && item.serial_barcode) {
                barcodeValue = item.serial_barcode
            }


            barcode = <Barcode  value={barcodeValue} height={settings.item_barcode_height} displayValue={settings.item_barcode_label}/>
            barcode2 = <BarcodeStyled value={barcodeValue} item={item} settings={settings}
               filename={barcodeValue+".png"} domNode="barcodestyled_wrapper"/>

          }

          pageHeader = <h3>{"Edit Item  #" + item.serial}</h3>
          deleteItemBtn = <button className="btn btn-danger" onClick={this.deleteItem}>Delete Item</button>
          if(!this.state.is_item_batches) {
            closing_stock =  <li>Closing Stock: <span className="label label-info">{Number(parseFloat(item.closing_stock))}</span></li>
            closing_purchase_basic_rate = <li>Closing Purchase Rate (CPR): <span className="label label-info">{parseFloat(item.closing_purchase_basic_rate)}</span></li>
          }

        }
        else {
          pageHeader =  <h3 >Create New Item</h3>
        }

        if(typeof this.state.deleteError !== "undefined") {
          deleteError = <p className="text-danger">{this.state.deleteError}</p>
        }

        return <div>
          {discountModal} {unitModal} {gstModal} {brandModal}
          <section className="medium">
                {pageHeader}
                {priceWarning}
                <ul className="list-inline">
                  {closing_stock}
                  {closing_purchase_basic_rate}


                  <li className="pull-right">{deleteItemBtn}<div>{deleteError}</div></li>
                </ul>
          </section>

          <div className="row">
            <div className="col-xs-12">
              {form}
              <ul className="list-unstyled list-inline">
                <li>{barcode}</li>
                <li>{barcode2}</li>
              </ul>
            </div>
          </div>
            <p className="text-danger">{submitError}</p>
            {batchList}
        </div>

      }
      else {
        return <div>
            <Loader />
        </div>
      }
  }
}


export default (EditItem)



// WEBPACK FOOTER //
// ./src/components/item/edititemnew.js